import React from 'react';
import TextLabel from "../../../Controls/TextLabel.mjs";
import NewChat from "./NewChat.mjs";
import ImWriteNewIcon from "../../../media/images/ImWriteNewIcon.mjs";
import {Button} from "reactstrap";
import ImIcon from "../../../media/images/ImIcon.mjs";
import CurrentChat from "./CurrentChat/CurrentChat.mjs";

const G = window.glob;

const ChatArea = class extends React.Component {
	constructor(props) {
		super(props);
		this.uid = G.generateUid('ChatArea');
	}
	render() {
		if (! this.props.chat ) return (
			<div className={"ChatArea EmptyChat"} id={this.uid} key={this.uid}>
				<div className={"box-title"}>
					<TextLabel value={"No chat"}/>
				</div>
				<div className={"box-wrap"}>
					<div className={"box-content box-top-center"}>
						<div className={"box-big-icon"}>
							<ImIcon/>
						</div>
						<div>
							<Button
								color="primary"
								className={"btn-icon"}
								onClick={e => {
									e.preventDefault();
									this.props.openChat('new:')
								}}
							>
								<b>
									<TextLabel value={"New chat"}/>
								</b>
								<i>
									<ImWriteNewIcon/>
								</i>
							</Button>
						</div>
					</div>
				</div>
			</div>
		);
		if (this.props.chat === 'new:') {
			return <NewChat {...this.props} />;
		}
		// if (this.props.chat.startsWith('group:') && this.props.chat.replace(/group:/, '')) {
		// 	return "Group";
		// }
		return <CurrentChat key={ this.props.chat } {...this.props} />;
	}
}

export default ChatArea;